export class VirtualGiftCard {
;
    constructor() {
    }
    imageUrl?: string;
    imageId?: number;
    imageDescription?: string;
    isImageBeingChanged?: boolean;
    amount?: number;
    recipientName?: string;
    recipientEmail?: string;
    senderName?: string;
    senderEmail?: string;
    recipientMessage?: string; 
    orderType?: string;
    scheduledHour?: string;
    scheduledTimeZone?: string;   
    scheduledDate?: string;
    scheduledDateTimeUtc?: string;
    tax?: number;
    total?: number
}

export class VirtualGiftCardOrder {
    
    constructor() {        
    }
    recipientName: string;
    senderName: string;
    orderId: number;
    recipientEmail: string;
    senderEmail: string;
    amount: number;
    sendDateTimeUtc: string;
    scheduledTimeZone: string;
    scheduledDate: string;
    scheduledHour: string;
}
